import React from 'react'
import Card from '../../../core/components/card/Card'
import SubjectToCSSName from '../../../core/less/SubjectToCSSName'
import {subjectToImageLight} from '../../../core/less/SubjectToImage'
import Box from '../../../core/components/box/Box'
import Heading from '../../../core/components/typography/heading/Heading'
import Text from '../../../core/components/typography/text/Text'
import './subTopicCard.css'

const DESCRIPTION_LENGTH = 120
class SubTopicCard extends React.PureComponent {

  render() {
    const {topic, topAncestor} = this.props
    const description = topic.description && topic.description.length > DESCRIPTION_LENGTH ? `${topic.description.substring(0,DESCRIPTION_LENGTH)}...` : topic.description
    return (
      <Box
        column={12}
        smColumn={6}
        marginBottom={4}>
        <Card
          display='flex'
          marginRight={0}
          smMarginRight={4}
          height='100%'
          to={topic.slug}
        >
          <Box
            display='flex'
            justifyContent='between'
            height='100%'
            alignItems='center'>
            {
              Object.prototype.hasOwnProperty.call(subjectToImageLight, topAncestor.id)
                ? <img className='subtopic-card__image' src={subjectToImageLight[topAncestor.id]} alt="" />
                : null
            }
            <div className='subtopic-card__content'>
              <div className='subtopic-card__title'>
                <Heading
                  size='md'
                  fontWeight='book'
                  accessibilityLevel={3}
                  color={`${SubjectToCSSName[topAncestor.id]}-nav`}
                  dangerouslySetInnerHTML={{ __html: topic.renderedTitle }}
                />
                <Box
                  flexShrink={0}
                  alignSelf='start'
                  marginTop={0}
                  marginLeft={0}
                  smMarginTop={1}
                  smMarginLeft={4}>
                  <Text
                    color='midGray'
                    size='sm'
                    fontWeight='book'>
                    {topic.num_leaves} Lessons
                  </Text>
                </Box>
              </div>
              <Text
                color='darkGray'
                leading='tall'
                size='sm'
                fontWeight='book'
                dangerouslySetInnerHTML={{ __html: description}} />
            </div>
          </Box>
        </Card>
      </Box>
    )
  }
}

export default SubTopicCard



// WEBPACK FOOTER //
// ./src/domains/topic/components/SubTopicCard.js